<template>
  <div class="wrapperqrnh">
        <Module ref="Module"
        :title="''"
        :desc="''"
        :emptyTitle="'暂无数据'"
        :moreTitle="'更多历史收益'"
        :fetchCache="fetchCache"
        :fetchRequest="fetchRequest"
        :loadStyle="'height: 315px'"
        :checkData="checkData"
        :moreEvent="clickMore">
          <div slot-scope="slotProps">
    <div class="single top">
      <span class="period">日期</span>
      <span class="syl">万元收益
        <img class="tip-icon-t"
        @click="showTips"
        src="../assets/warn-tip-gray.png"
        v-if="showTipAlet" />
      </span>
      <span class="rank">7日年化</span>
    </div>
    <div class="single bottom" v-for="(item, index) in slotProps.list" v-bind:key="index">
      <div class="period">
        <div>{{item.FSRQ}}</div>
        <div class="fh-tip" v-if="showFhTip(item.sorFSRQ,fhDatalist)">分红</div>
      </div>
      <span class="syl">{{item.DWJZ}}
        <span class="red-tip" v-if="item.NAVTYPE === '0'">*</span>
      </span>
      <span :class="['rank', `${upDown(item.LJJZ)}`]">{{`${item.LJJZ}%`}}</span>
    </div>
          </div>
        </Module>
  </div>
</template>

<style lang="less" scoped>
.wrapperqrnh {
  background-color: white;
  padding-left: 24px;
  padding-right: 24px;
  border-radius: 12px;
}
.single {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 90px;
}
.gray {
  color: @app-color-stay;
}
.red {
  color: @app-color-up;
}
.green {
  color: @app-color-down;
}
.top {
  font-family: PingFangSC-Regular;
  color: #999999;
  font-size: 28px;
  .period {
    text-align: left;
    width: 30%;
  }
  .syl {
    text-align: center;
    width: 36%;
  }
  .rank {
    text-align: right;
    width: 33%;
  }
}
.bottom {
  font-size: 32px;
  font-family: DINAlternate-Bold;
  .period {
    text-align: left;
    flex-direction: row;
    display: flex;
    width: 30%;
  }
  .syl {
    text-align: center;
    width: 36%;
  }
  .rank {
    text-align: right;
    width: 33%;
  }
  .rank-wrap {
    text-align: right;
    flex-shrink: 0;
    .rank {
      color: black;
    }
    .sc {
      color: #666666;
    }
  }
}
.more-wrapper {
  background-color: #ffffff;
  border-top: 1px solid #eeeeee;
  padding: 30px;
}
.red-tip{
  color: @app-color-up;
}

.tip-icon-t{
  height: 24px;
  width: 24px;
  margin-left: 5px;
}

.more-text {
  font-size: 30px;
  color: #008aff;
  text-align: center;
  line-height: 30px;
}

.fh-tip{
  flex: 1;
  margin-left: 10px;
  width: 56px;
  background: rgba(255, 100, 52, 0.1);
  border-radius: 4px;
  font-size: 20px;
  color: rgb(255, 100, 52);
  text-align: center;
  padding-top: 4px;
  padding-bottom: 4px;
}
</style>

<script>
import Module from '@/components/Module.vue';
import StoreManger from '@/utils/FundHQJHManger';
import JS from '@/base/JSTool';
import {
  detailPushPage,
} from '@/utils/nativeBridge';

export default {
  name: 'mark-period-increase',
  components: {
    Module,
  },
  props: {},
  watch: {},
  data() {
    return {
      fundCode: '',
      fundType: '',
      unit: '万',
      showTipAlet: false,
      fhDatalist: [],
    };
  },
  computed: {},
  created() {
  },
  mounted() {
    this.render();
  },
  methods: {
    render() {
      this.fundCode = this.$store.state.native.fund.fundCode;
      this.fundType = this.$store.state.native.fund.fundType;

      const fundinfo = StoreManger.getFundJJXQ();
      const fetch = (key) => {
        const res = JS.fetchString(fundinfo, key);
        return res || '--';
      };
      const FEATURE = fetch('FEATURE');
      let unit = '万';
      if (FEATURE.indexOf('090') !== -1) {
        unit = '百万';
      } else if (FEATURE.indexOf('100') !== -1) {
        unit = '百';
      }
      this.unit = unit;
      if (this.needRequestData()) {
        this.$refs.Module.start();
      } else {
        this.$refs.Module.cache();
      }
    },
    needRequestData() {
      const fundId = this.$store.state.quotation.fund[`${this.fundCode}NetList`];
      let needReq = true;
      if (fundId) {
        if (fundId.ctime) {
          const now = new Date().getTime();
          const during = now - fundId.ctime;
          if (during < 2 * 60 * 1000) {
            needReq = false;
          }
        }
      }
      return needReq;
    },
    fetchCache() {
      const fundId = this.$store.state.quotation.fund[`${this.fundCode}NetList`];
      return this.handleData(fundId);
    },
    fetchRequest() {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch('updateNetList', { id: this.fundCode, isShareNet: false })
          .then((res) => {
            const resData = this.handleData(res);
            resolve(resData);
          })
          .catch(() => {
            reject();
          });
      });
    },
    checkData(data) {
      return (data && Object.prototype.toString.call(data) === '[object Array]' && data.length > 0);
    },
    showFhTip(sorFSRQ, fhDatalist) {
      if (sorFSRQ && fhDatalist && fhDatalist.length > 0) {
        const lists = fhDatalist.join(',');
        if (lists) {
          return (lists.indexOf(sorFSRQ) !== -1);
        }
      }
      return false;
    },
    handleDefault() {
    },
    handleData(data) {
      const arr = [];
      if (data && data.Datas) {
        if (data.Expansion && data.Expansion.BonusList && data.Expansion.BonusList.length > 0) {
          const charr = [];
          data.Expansion.BonusList.forEach((el) => {
            charr.push(el.FSRQ);
          });
          this.fhDatalist = charr;
        }
        const list = data.Datas;
        if (list) {
          let newList = list;
          if (list.length >= 5) {
            newList = list.slice(0, 5);
          }
          newList.forEach((el) => {
            if (el.NAVTYPE === '0') {
              this.showTipAlet = true;
            }
            arr.push(this.format(el));
          });
        }
      }
      return arr;
    },
    format(item) {
      const fetch = (key) => {
        const res = JS.fetchString(item, key);
        return res || '--';
      };
      return {
        FSRQ: fetch('FSRQ').substring(5),
        sorFSRQ: fetch('FSRQ'),
        DWJZ: fetch('DWJZ'),
        LJJZ: fetch('LJJZ'),
        JZZZL: fetch('JZZZL'),
        NAVTYPE: item.NAVTYPE,
      };
    },
    upDown(value) {
      const newV = parseFloat(value);
      if (newV > 0) {
        return 'red';
      }
      if (newV < 0) {
        return 'green';
      }
      return 'gray';
    },
    showTips() {
      this.$feedback.showModal({
        title: '温馨提示',
        content: '*代表多天合并数据。',
        confirmText: '知道了',
        confirmColor: '#f40',
        showCancel: false,
      });
    },
    clickMore() {
      const baseInfo = StoreManger.getFundJJXQ();
      const name = StoreManger.getFundJJXQNAME(baseInfo);
      detailPushPage({
        appId: '516939c37bdb4ba2b1138c50cf69a2e1',
        url: '/pages/FundHistoryIncome',
        params: {
          fundCode: this.fundCode,
          fundName: name,
          featuretype: baseInfo.FEATURE,
        },
      });
    },
  },
};
</script>
